import {
  DateField,
  FunctionField,
  ListButton,
  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
} from "react-admin";

import { TICKET_TYPES } from "./constants";

const ShowActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
  </TopToolbar>
);

export const TicketShow = () => (
  <Show actions={<ShowActions />}>
    <SimpleShowLayout>
      <TextField source="id" />
      <TextField source="heartbeatName" />
      <TextField source="deviceId" />
      <TextField source="email" />
      <TextField source="issue" />
      <TextField source="systemInfo" />
      <DateField source="createAt" />
      <DateField source="updateAt" />
      <TextField source="clientAppId" />
      <FunctionField
        source="type"
        render={(record: { type?: keyof typeof TICKET_TYPES }) =>
          record.type ? TICKET_TYPES[record.type] : ""
        }
      />
    </SimpleShowLayout>
  </Show>
);
